// Types for sunset data from Dune Analytics

export interface PairData {
  chain: string
  chainId: number
  pairAddress: string
  pairSymbol: string
  tvlUsd: number
  token0Address: string
  token1Address: string
  createdAt: string
}

export interface LPHolder {
  chain: string
  chainId: number
  pairAddress: string
  pairSymbol: string
  userAddress: string
  balance: number
  balanceUsd: number
  lastUpdated: string
}

export interface FarmStaker {
  chain: string
  chainId: number
  farmAddress: string
  pairAddress: string
  pairSymbol: string
  userAddress: string
  stakedBalance: string
  stakedBalanceFormatted: number
}

export interface SunsetData {
  pairs: PairData[]
  holders: LPHolder[]
  farmStakers: FarmStaker[]
  lastUpdated: string
}

// Chain ID mapping
export const CHAIN_IDS: Record<string, number> = {
  polygon: 137,
  bnb: 56,
  arbitrum: 42161,
  ethereum: 1
}

// Farm contract addresses (same on Polygon and BSC)
export const FARM_ADDRESSES: Record<number, string> = {
  137: '0x3dD417Ff4144bE35f203CB2CA569adF01Cd3574a', // Polygon
  56: '0x3dD417Ff4144bE35f203CB2CA569adF01Cd3574a' // BSC
}

// Router address (same on all chains)
export const ROUTER_ADDRESS = '0xe4C5Cf259351d7877039CBaE0e7f92EB2Ab017EB'

// Factory address (same on all chains)
export const FACTORY_ADDRESS = '0x5f8017621825BC10D63d15C3e863f893946781F7'
